import { ServiceResponse, EnquiryDto, CreateEnquiryDto } from "../../platform/models";

const IEnquiryFormServiceId = Symbol("IEnquiryFormService");

interface IEnquiryFormService {
    SubmitEnquiryForm(enquiryDto: CreateEnquiryDto, antiForgeryToken: string): Promise<ServiceResponse<EnquiryDto>>;
};

export { IEnquiryFormServiceId, IEnquiryFormService }